import React, {useState, useEffect, useMemo} from "react";
import { useNavigate } from "react-router-dom";
import Menu from "../../../../components/layout/menu/index";
import banner from "../../../../assets/images/logos/banner-benefits.svg"
import {getBenefitsPerSupplier, getBenefits } from "../../../../client/administration/benefits";
import BenefitsCard from "../../../../components/card/benefitsCard";
import { motion } from "framer-motion"; 
import benefit from "../../../../assets/images/background/benefits-circle.svg"
import '../../../../../src/index.css';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import { useAuth } from "../../../../context/auth";
import { useModuleAdherence } from "../../../../hooks/userAdherence/index";

export default function Benefits() {
  useModuleAdherence(1);
  const {supplierId} = useAuth();
  const navigate = useNavigate();

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const [animationTime, setAnimationTime] = useState(0);

  useEffect(() => {
    let animationId;
    let startTime = null;

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      setAnimationTime(elapsed);
      animationId = requestAnimationFrame(animate);
    };

    animationId = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationId);
    };
  }, []);

  const [benefitsData, setBenefitsData] = useState({
    supplierName: "",
    finalScore: 0,
    benefits:[]
  });

  const [allBenefits, setAllBenefits] = useState([]);
  const [selectedPercentage, setSelectedPercentage] = useState(null); 

  useEffect(() => {
    const fetchData = async () => {
      try {
        const allBenefitsResponse = await getBenefits();
        const filteredAllBenefits = allBenefitsResponse.data.filter(b => b.visible !== false);

        setAllBenefits(filteredAllBenefits);

        if (supplierId) {
          const supplierBenefitsResponse = await getBenefitsPerSupplier(supplierId);
          const filteredSupplierBenefits = {
            ...supplierBenefitsResponse.data,
            benefits: supplierBenefitsResponse.data.benefits.filter(b => b.visible !== false)
          };
          setBenefitsData(filteredSupplierBenefits);
        }
      } catch (error) {
        console.error('Error fetching benefits:', error);
      }
    };

    fetchData();
  }, [supplierId]);


  const combinedBenefits = useMemo(() => {
    return allBenefits
      .filter(benefit => benefit.visible !== false) 
      .map(benefit => {
        const hasBenefit = benefitsData.benefits.some(b => b.id === benefit.id);
        return {
          ...benefit,
          isDisabled: !hasBenefit && benefit.percente > benefitsData.finalScore
        };
      });
  }, [allBenefits, benefitsData]);

  const groupedBenefits = combinedBenefits.reduce((acc, benefit) => {
    const percente = benefit.percente;
    if (!acc[percente]) {
      acc[percente] = [];
    }
    acc[percente].push(benefit);
    return acc;
  }, {});

  const percentes = Object.keys(groupedBenefits)
    .map(Number)
    .sort((a, b) => b - a);

  const sortedPercentes = percentes.slice().sort((a, b) => b - a);
  const renderPercentes = [...sortedPercentes].reverse();

  const handleEvaluationClick = () => {
    navigate(`/mi-evaluacion/${supplierId}`);
  };

  const hasBenefits = useMemo(() => {
    return Object.keys(groupedBenefits).length > 0;
  }, [groupedBenefits]);

  return (
    <div>
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300"/>
      <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"} bg-[#F7F8F9] w-full z-50 min-h-screen`}>
        <div className="sm:pt-8 pt-4 pb-10 px-[4%] sm:px-[3%]">
            <div className="flex flex-col gap-3">
                <img src={banner} alt="Beneficios especiales" className="object-cover h-[194px] w-full"/>
                <div className={`flex flex-col ${hasBenefits ? '' : 'items-center'}  w-full gap-6 mt-6 sm:flex-row`}>
                  <div className="bg-blue bg-opacity-10 gap-4 flex flex-col w-full sm:w-[28%] px-12 p-7 sm:p-7">
                    <h1 className="text-[#184A7D] font-itcmedium text-xl sm:text-2xl break-words  lg:text-[32px]  !leading-[1.5] [line-height:1.5!important]">Hola {benefitsData.supplierName}, tu puntaje es de <span className="text-green font-itcbold">{benefitsData.finalScore}% de 100%</span></h1>
                    <p className="text-[#184A7D] font-itcmedium text-sm lg:text-base">¿Quieres saber a detalle el porqué de tu puntaje?</p>
                    <button onClick={handleEvaluationClick}
                            className="p-2 bg-green w-full flex justify-center items-center rounded-lg text-white font-itcdemi md:text-[18px] text-lg">
                      Ingresa aquí
                    </button>
                  </div>
  
                  <div className="w-full sm:w-[72%] h-full px-[4%] pb-4 relative flex justify-center items-center ">
                    {hasBenefits ? (
                    <>
                      <img
                        src={benefit}
                        alt="Background"
                        className="absolute z-0 w-full transform -translate-x-1/2 -bottom-4 left-1/2"
                      />
                      
                      <svg width="100%" height="100%"   
                        viewBox={percentes.length === 2 ? "0 0 700 850" :
                                percentes.length === 1 ?  "0 0 700 620" : "0 0 700 700"}   
                        preserveAspectRatio="xMidYMid meet"
                        className="relative z-0 h-auto">
                      
                        {renderPercentes.map((percente, index, array) => {
                          //espacio entre escalones
                          const stepSpacing = percentes.length === 4 ? 142 :
                                              percentes.length === 3 ? 195 :
                                              percentes.length === 2 ? 350 : 112;
                                              
                          const stepHeight =  percentes.length === 4 ? 50 :
                                              percentes.length === 3 ? 60:
                                              percentes.length === 2 ? 160:
                                              percentes.length === 1 ? 190: 50;
  
                          const y = percentes.length === 1 ? 218 : 625 - index * stepSpacing ; // Mayor separación vertical entre escalones
                          const depth = percentes.length === 3 ? 50:
                                        percentes.length === 1 ? -20:30; // Profundidad ajustada
                          const frontHeight = stepHeight; // Altura de la parte frontal
                          const offsetX = index * (percentes.length === 3 ? 170:
                                                  percentes.length === 2 ? 280:
                                                  percentes.length === 1 ? -280: 110); // Desplazamiento horizontal (ajustado para incluir escalones vacíos)
  
                          const stepWidth = (percentes.length === 2? 270:
                                            percentes.length === 1 ? 350: 180); // Ancho del escalón
                          const topWidth =  percentes.length === 4 ? 1650 :
                                            percentes.length === 3 ? 1850 :
                                            percentes.length === 2 ? 2050 :
                                            percentes.length === 1 ? 2000 : 1450; // Ancho en perspectiva
  
                          const textX = (50 + stepWidth / 2) + offsetX; // Posición horizontal del texto
                          const textY = y + (frontHeight / (percentes.length === 3 ? 1.5 :
                                                            percentes.length === 2 ? 1.8 :
                                                            percentes.length === 1 ? 1.6 : 1.1)); // Posición vertical del texto
                          const isBottomStep = index === 0; // Último escalón (abajo)
                          const isTopStep = index === array.length - 1; // Primer escalón (arriba)
                          const emptyOffsetX = offsetX - (percentes.length === 3 ? 90 :
                                                          percentes.length === 2 ? 160 :
                                                          percentes.length === 1 ? 60 : 60); // Desplazamiento horizontal adicional
                          
                          return (
                            <>
                              {/* Escalón vacío (colocado debajo del escalón con porcentaje) */}
                              {(!isBottomStep || percentes.length === 1)  && (
                                <g key={`empty-step-${percente}`} >
                                  {/* Parte superior del escalón vacío */}
                                  <polygon
                                    points={`
                                      ${50 + emptyOffsetX},${y + (percentes.length === 4 ? 70 :
                                                                  percentes.length === 3 ? 90 :
                                                                  percentes.length === 1 ? frontHeight + 15 : frontHeight + 10)} 
  
                                      ${50 + emptyOffsetX + stepWidth},${y + frontHeight + (percentes.length === 4 ? 40 :
                                                                                            percentes.length === 3 ? 70 : 30)} 
  
                                      ${50 + emptyOffsetX + topWidth},${y + frontHeight - depth + (percentes.length === 4 ? 0 :
                                                                                                  percentes.length === 3 ? 0 : 10)} 
  
                                      ${50 + emptyOffsetX + (topWidth - stepWidth)},${y + frontHeight - depth - (percentes.length === 4 ? 260 :
                                                                                                                percentes.length === 3 ? 368 :
                                                                                                                percentes.length === 2 ? 338 :
                                                                                                                percentes.length === 1 ? 490 : 100)}
                                    `}
                                    fill="#FFFFFF"
                                  />
  
                                  {/* Parte frontal del escalón vacío */}
                                  <polygon
                                    points={`
                                      ${50 + emptyOffsetX},${y + frontHeight + (percentes.length === 4 ? 20 :
                                                                                percentes.length === 3 ? 28 :
                                                                                percentes.length === 2 ? 10 : 10)}
  
                                      ${50 + emptyOffsetX + stepWidth},${y + frontHeight + (percentes.length === 4 ? 30 :
                                                                                            percentes.length === 3 ? 30 :
                                                                                            percentes.length === 2 ? 20 : 20)} 
  
                                      ${50 + emptyOffsetX + stepWidth},${y + frontHeight + (percentes.length === 4 ? 93 :
                                                                                            percentes.length === 3 ? 107 :
                                                                                            percentes.length === 2 ? 160 :
                                                                                            percentes.length === 1 ? 180 : 63)} 
  
                                      ${50 + emptyOffsetX},${y + frontHeight + (percentes.length === 4 ? 80 :
                                                                                percentes.length === 3 ? 98 :
                                                                                percentes.length === 2 ? 145 :
                                                                                percentes.length === 1 ? 165 : 56)}
                                    `}
                                    fill="#E7E8E9"
                                  />
  
                                  {/* Parte lateral del escalón vacío */}
                                  <polygon
                                    points={`
                                      ${50 + emptyOffsetX + stepWidth},${y + frontHeight + (percentes.length === 4 ? 30 :
                                                                                            percentes.length === 3 ? 30 : 20)} 
  
                                      ${50 + emptyOffsetX + topWidth},${y + frontHeight - depth - (percentes.length === 4 ? 140 :
                                                                                                  percentes.length === 3 ? 230 :
                                                                                                  percentes.length === 2 ? 320 :
                                                                                                  percentes.length === 1 ? 520 : 140)} 
  
                                      ${50 + emptyOffsetX + topWidth},${y + frontHeight - (percentes.length === 4 ? 0 :
                                                                                          percentes.length === 3 ? 30 :
                                                                                          percentes.length === 2 ? -90 :
                                                                                          percentes.length === 1 ? 200 : 70)} 
  
                                      ${50 + emptyOffsetX + stepWidth},${y + frontHeight + (percentes.length === 4 ? 98 :
                                                                                            percentes.length === 3 ? 110 :
                                                                                            percentes.length === 2 ? 210 :
                                                                                            percentes.length === 1 ? 180 : 90)}
                                    `}
                                    fill="#D1D5D8"
                                  />
                                </g>
                              )}
  
                              {/* Escalón con porcentaje */}
          <motion.g 
            key={`step-${percente}`}
            initial={{ scale: 1}}
            animate={{
              scale: 1 + Math.sin(animationTime / 2000 * Math.PI) * 0.02,
            }}
            whileTap={{ scale: 0.98 }}
          >
                                {/* Parte superior del escalón */}
                                {!isTopStep && (
                                  <polygon
                                    points={`
                                      ${50 + offsetX},${y + (percentes.length === 3? -14 :
                                                            percentes.length === 2? 0 : 0)} 
  
                                      ${50 + offsetX + stepWidth},${y + (percentes.length === 4 ? 30 :
                                                                        percentes.length === 3 ? 10 :
                                                                        percentes.length === 2 ? 20 : 20)} 
  
                                      ${50 + offsetX  + topWidth},${y - depth } 
  
                                      ${50 + offsetX + (topWidth - stepWidth)},${y - depth - (percentes.length === 4 ? 340 :
                                                                                              percentes.length === 3 ? 470 :
                                                                                              percentes.length === 2 ? 630 : 130)}
                                    `}
                                    fill="#FFFFFF"
                                  />
                                )}
  
                                {/* Parte frontal del escalón */}
                                <polygon
                                  points={`
                                    ${50 + offsetX},${isBottomStep ? y + (percentes.length === 3 ? -14 :
                                                                          percentes.length === 1 ? 14 : 0) : isTopStep ? y + (percentes.length === 4 ? 2 :
                                                                                                                              percentes.length === 3 ? -9 : 6) : (percentes.length === 3 ? -14 : 0) + y} 
  
                                    ${50 + offsetX + stepWidth},${isBottomStep ? y + (percentes.length === 4 ? 10 :
                                                                                      percentes.length === 3 ? -10 :
                                                                                      percentes.length === 1 ? 15 : 15) : y + (percentes.length === 4 ? 10 :
                                                                                                                                percentes.length === 3 ? -10 : 10)} 
  
                                    ${50 + offsetX + stepWidth},${isBottomStep ? y + frontHeight + (percentes.length === 4 ? 24 :
                                                                                                    percentes.length === 3 ? 14 :
                                                                                                    percentes.length === 1 ? -0 : 25) : y + frontHeight + (percentes.length === 4 ? 21 :
                                                                                                                                                          percentes.length === 3 ? 12 :
                                                                                                                                                          percentes.length === 2 ? -15 : 11)} 
  
                                    ${50 + offsetX},${isBottomStep ? y + frontHeight + (percentes.length === 3 ? -3 :
                                                                                        percentes.length === 1 ? -7 : 0) : y + frontHeight + (percentes.length === 4 ? 7 :
                                                                                                                                            percentes.length === 3 ? 6 :
                                                                                                                                            percentes.length === 2 ? -22 : 3.5)}
                                  `}
                                  fill={selectedPercentage === percente ? "#93D0EE" : "#E7E8E9"}
                                  className="transition-colors duration-300 cursor-pointer"
                                  onClick={() =>
                                    setSelectedPercentage(selectedPercentage === percente ? null : percente)
                                  }
                                />
  
                                {/* Parte lateral del escalón */}
                                {isTopStep ? (
                                  /* Escalón de arriba (modificado) */
                                  <polygon
                                    points={`
                                      ${50 + offsetX + stepWidth},${y + (percentes.length === 4 ? 10 :
                                                                        percentes.length === 3 ? -10 :
                                                                        percentes.length === 1 ? 15 : 10)} 
  
                                      ${50 + offsetX + topWidth},${y - depth + (percentes.length === 4 ? -160 :
                                                                                percentes.length === 3 ? -50 :
                                                                                percentes.length === 1 ? -95 : 14)} 
  
                                      ${50 + offsetX + topWidth},${y + (percentes.length === 4 ? 33 :
                                                                        percentes.length === 3 ? 33 :
                                                                        percentes.length === 1 ? 200 : 33)} 
  
                                      ${50 + offsetX + stepWidth},${y + depth + (percentes.length === 4 ? 53 :
                                                                                percentes.length === 3 ? 53 :
                                                                                percentes.length === 2 ? 120 :
                                                                                percentes.length === 1 ? 320 : 53)}
                                    `}
                                    fill="#D1D5D8"
                                  />
                                ) : (
                                  /* Escalones normales */
                                  <polygon
                                    points={`
                                      ${50 + offsetX + stepWidth},${isBottomStep ? y + (percentes.length === 4 ? 10 :
                                                                                        percentes.length === 3 ? -10 :
                                                                                        percentes.length === 2 ? 15 : 15) : y + (percentes.length === 4 ? 10 :
                                                                                                                                  percentes.length === 3 ? -10 : 10)} 
  
                                      ${50 + offsetX + topWidth},${isBottomStep ? y - depth - (percentes.length === 4 ? 200 :
                                                                                                percentes.length === 3 ? 290 :
                                                                                                percentes.length === 2 ? 624 : 260) : y - depth - (percentes.length === 4 ? 190 :
                                                                                                                                                  percentes.length === 3 ? 280 :
                                                                                                                                                  percentes.length === 2 ? 190 : 190)} 
  
                                      ${50 + offsetX + topWidth},${isBottomStep ? y- (percentes.length === 4 ? 120 :
                                                                                      percentes.length === 3 ? 120 :
                                                                                      percentes.length === 2 ? 120 : 120) : y - (percentes.length === 4 ? 120 :
                                                                                                                                  percentes.length === 4 ? 120 : 100)} 
                                                                                                                                  
                                      ${50 + offsetX + stepWidth},${isBottomStep ? y + depth + (percentes.length === 4 ? 44 :
                                                                                                percentes.length === 3 ? 24 :
                                                                                                percentes.length === 2 ? 154 : 45) : y + depth + (percentes.length === 4 ? 51 :
                                                                                                                                                percentes.length === 3 ? 51 : 41)}
                                    `}
                                    fill="#D1D5D8"
                                  />
                                )}
  
                                {/* Texto del porcentaje */}
                                <text
                                  x={textX}
                                  y={textY}
                                  fontSize={percentes.length <= 2 ? "48" : "32"}
                                  textAnchor="middle"
                                  className="cursor-pointer fill-[#184A7D] font-itcbold"
                                  transform={`rotate(1.24, ${textX}, ${textY})`}
                                  onClick={() =>
                                    setSelectedPercentage(selectedPercentage === percente ? null : percente)
                                  }
                                >
                                      <tspan>{percente}%</tspan>
                                </text>
  
  
                                {isTopStep && (
                                  <g transform={`translate(${textX }, ${y - (percentes.length === 3 ? 80 : 60)})`}>
                                    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M51.6667 18.3785V18.5489C51.6667 20.5555 51.6667 21.5612 51.1837 22.3825C50.7007 23.2039 49.821 23.6915 48.0663 24.6692L46.216 25.6959C47.49 21.3839 47.917 16.7499 48.0733 12.7879L48.0967 12.2722L48.1013 12.1509C49.6203 12.6782 50.4743 13.0725 51.0063 13.8099C51.6667 14.7269 51.6667 15.9449 51.6667 18.3785ZM5 18.3785V18.5489C5 20.5555 5 21.5612 5.483 22.3825C5.966 23.2039 6.84567 23.6915 8.60033 24.6692L10.453 25.6959C9.17667 21.3839 8.74967 16.7499 8.59333 12.7879L8.57 12.2722L8.56767 12.1509C7.04633 12.6782 6.19233 13.0725 5.66033 13.8099C5 14.7269 5 15.9472 5 18.3785Z" fill="#184A7D"/>
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M38.5463 4.81019C35.1704 4.25719 31.7542 3.98636 28.3333 4.00053C24.173 4.00053 20.743 4.36686 18.1203 4.81019C15.4626 5.25819 14.135 5.48219 13.0243 6.84953C11.916 8.21686 11.9743 9.69386 12.091 12.6479C12.4946 22.7932 14.6833 35.4679 26.5833 36.5879V44.8339H23.2466C22.7074 44.8342 22.185 45.0213 21.7681 45.3633C21.3512 45.7053 21.0657 46.1811 20.96 46.7099L20.5166 48.9172H14.3333C13.8692 48.9172 13.4241 49.1016 13.0959 49.4298C12.7677 49.7579 12.5833 50.2031 12.5833 50.6672C12.5833 51.1313 12.7677 51.5765 13.0959 51.9046C13.4241 52.2328 13.8692 52.4172 14.3333 52.4172H42.3333C42.7974 52.4172 43.2426 52.2328 43.5707 51.9046C43.8989 51.5765 44.0833 51.1313 44.0833 50.6672C44.0833 50.2031 43.8989 49.7579 43.5707 49.4298C43.2426 49.1016 42.7974 48.9172 42.3333 48.9172H36.15L35.7066 46.7099C35.601 46.1811 35.3154 45.7053 34.8985 45.3633C34.4816 45.0213 33.9592 44.8342 33.42 44.8339H30.0833V36.5879C41.9833 35.4679 44.1743 22.7955 44.5756 12.6479C44.6923 9.69386 44.753 8.21453 43.6423 6.84953C42.5316 5.48219 41.204 5.25819 38.5463 4.81019Z" fill="#184A7D"/>
                                    </svg>
                                  </g>
                                )}
                              </motion.g>
                            </>
                          );
                        })}
  
  
                        {renderPercentes.map((percente, index) => {
                          if (selectedPercentage !== percente) return null;                  
                          const y = (percentes.length === 3 ? 620 :
                                     percentes.length === 1 ? 230 : 625)  - index * (percentes.length === 3 ? 198 :
                                                                                     percentes.length === 4 ? 139 :
                                                                                     percentes.length === 2 ? 339 : 110); // Posición vertical de los escalones
                          const cardY = y - 180; // Ajusta la posición vertical de los cards
                          const offsetX = index * 92;
                          const stepWidth = 220; // Ancho del escalón
                          return (
                            <foreignObject
                             key={percente}
                             x={
                              //primer escalon
                              index === renderPercentes.length - 1 
                                ? groupedBenefits[percente].length >= 3 // mas de 3 card
                                  ? (percentes.length === 4 ? 210 :
                                    percentes.length === 3 ? 320 :
                                    percentes.length === 2 ? 400 :
                                    percentes.length === 1 ? 260 : 140) + offsetX + (stepWidth / 2) - 350 
  
                                  : groupedBenefits[percente].length === 1 // 1 card
                                  ? (percentes.length === 3 ? 350 :
                                    percentes.length === 2 ? 400 : 250) + offsetX + (stepWidth / 2) - 350 
  
                                  : (percentes.length === 3 ? 380 : // 2 card
                                    percentes.length === 2 ? 460 :
                                    percentes.length === 1 ? 240 : 210) + offsetX + (stepWidth / 2) - 350 
  
                              //segundo escalon arriba
                              : index === renderPercentes.length - 2
                              ? groupedBenefits[percente].length >= 3 //3 cards a mas
                              ? (percentes.length === 3 ? 250 :
                                percentes.length === 2 ? 252 : 220) + offsetX + (stepWidth / 2) - 350
  
                              : groupedBenefits[percente].length === 1 // un card
                              ? (percentes.length === 4 ? 210 : 240) + offsetX + (stepWidth / 2) - 350 
  
                              : (percentes.length === 3 ? 240 : // 2 cards
                                percentes.length === 2 ? 240 : 200) + offsetX + (stepWidth / 2) - 350 
                        
                              // ultimo escalon
                              : index === 0
                              ? groupedBenefits[percente].length >= 3 // mas de 3 cards
                                ? 240 + offsetX + ( stepWidth / 2) - 350 
  
                                : groupedBenefits[percente].length === 1 // 1 card
                                ? 180 + offsetX + (stepWidth/2) - 350 
  
                                : 170 + offsetX + (stepWidth/2) - 350 // 2 card
  
                              //otros escalones
                              : groupedBenefits[percente].length >= 3 // mas de 3 cards
                              ? 200 + offsetX + (stepWidth / 2) - 350 
  
                              : groupedBenefits[percente].length === 1 // 1 card
                              ? 190 + offsetX + (stepWidth / 2) - 350 
  
                              : 198 + offsetX + (stepWidth / 2) - 350 // 2 cards
                            }
                             y={cardY}
                             width="435"
                             height="180"
                             className="absolute z-20"
                            >
                             
                             <SimpleBar className="benefits-simplebar" style={{ overflowX: "auto", overflowY:"hidden" }}>
                               <motion.div
                                 xmlns="http://www.w3.org/1999/xhtml"
                                 className=""
                                 style={{
                                   display: "flex",
                                   gap: "13px",
                                   width: "100%",
                                   position: "relative",
                                   zIndex: 10,
                                   justifyContent: groupedBenefits[percente].length >= 3 ? "start" : "center", 
                                 }}
                                 initial={{ opacity: 0, y: 10 }}
                                 animate={{ opacity: 1, y: 0 }}
                                 transition={{ duration: 0.3, ease: "easeOut" }}
                               >
                              
                                {groupedBenefits[percente]
                                  .filter(benefit => benefit.visible !== false) 
                                  .map((benefit, i) => (
                                    <BenefitsCard key={i} benefit={benefit} isDisabled={benefit.isDisabled} />
                                  ))
                                }
                               </motion.div>
                             </SimpleBar>
                            </foreignObject>
                          );
                        })}
                      </svg>
                    </>
                    ) : (
                      <div className="flex items-center justify-center h-full">
                          <p className="text-blue font-itcmedium text-[4vw] sm:text-[2vw] text-center">
                            No hay beneficios registrados por el momento.
                          </p>
                      </div>
                    )}
                  </div> 
                </div>
            </div>
        </div>
      </div>
    </div>
  );
}